import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import EventEmitter from 'events';
import assign from 'object-assign';


const CHANGE_EVENT = 'change';
const FORM_CHANGE_EVENT = 'form_change';

let _entities = [];
let _tinCanList = [];


var CourseActivityStore = assign({}, EventEmitter.prototype, {

    emitChange: function() {
        this.emit(CHANGE_EVENT);
    },
    addChangeListener: function(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    addFormChangeListener: function(callback) {
        this.on(FORM_CHANGE_EVENT, callback);
    },
    removeChangeListener: function(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    getTinCanList: function(courseId, userId) {
        if (userId === undefined) {
            return _tinCanList.filter(function(e) { return e !== undefined && e.courseId == courseId; });
        } else {
            return _tinCanList.filter(function(e) { return e !== undefined && e.courseId == courseId && e.learnerId == userId; });
        }
    },
    addTinCanList: function(data) {
        if (data.learnerId !== undefined && data.courseId !== undefined && data.tinCanId !== undefined) {
            var index = _tinCanList.findIndex(function(e) {
                return e !== undefined && e.courseId == data.courseId && e.learnerId == data.learnerId && e.tinCanId == data.tinCanId;
            });
            if (index < 0) {
                _tinCanList.push(data);
            }
        }
    },
        
});

CourseActivityStore.dispatchToken = CentricDispatcher.register(function(action) {

    switch(action.type) {

        case ActionTypes.COURSE_ACTIVITY_TINCAN_LIST:
            action.data.forEach(CourseActivityStore.addTinCanList);
            CourseActivityStore.emitChange();
            break;
            
        default:
            break;

    }

});

export default CourseActivityStore;
